import { cloneDeep, isArray, isPlainObject } from 'lodash';
import config, { Currency } from '../config';
;
var formatNumber = function (value, props) {
    if (props === void 0) { props = {}; }
    if (value > 1e20) {
        throw "Numbers bigger than 1e20 are unsupported";
    }
    value = parseFloat(value.toFixed(20));
    var decimals = props.decimals, fixedDecimals = props.fixedDecimals;
    var thousandsSeparator = props.thousandsSeparator || config.thousands_separator || '.';
    var decimalSeparator = props.decimalSeparator || config.decimal_separator || ',';
    if (typeof decimals != 'undefined') {
        value = round(value, decimals);
    }
    var output = value + '';
    var _a = output.split('.'), baseValue = _a[0], decimalValue = _a[1];
    if (typeof decimalValue == 'undefined') {
        decimalValue = '';
    }
    output = addThousandsSeparator(parseInt(baseValue), thousandsSeparator);
    if (decimalSeparator && (decimalValue != '' || fixedDecimals)) {
        output = addDecimalSeparator(output, decimalValue, decimalSeparator, fixedDecimals ? decimals : null);
    }
    return output;
};
var formatInteger = function (value) {
    return formatNumber(value);
};
;
var formatMoney = function (value, props) {
    var _a;
    if (props === void 0) { props = {}; }
    var symbols = (_a = {},
        _a[Currency.Euro] = '€ ',
        _a);
    var symbol = typeof props.symbol != 'undefined' ? (props.symbol || '') : symbols[config.currency];
    var decimals = typeof props.decimals != 'undefined' ? props.decimals : 2;
    var fixedDecimals = typeof props.fixedDecimals != 'undefined' ? props.fixedDecimals : true;
    return symbol + formatNumber(value / 100, { decimals: decimals, fixedDecimals: fixedDecimals });
};
;
var parseNumber = function (value, props) {
    if (props === void 0) { props = {}; }
    var thousandsSeparator = props.thousandsSeparator || config.thousands_separator || '.';
    var decimalSeparator = props.decimalSeparator || config.decimal_separator || ',';
    value = value.replace(new RegExp("\\".concat(thousandsSeparator), 'g'), '').replace(new RegExp("\\".concat(decimalSeparator), 'g'), '.').replace(/[^0-9\.-]/g, '');
    return parseFloat(value);
};
var parseInteger = function (value) {
    return parseNumber(parseInt(value) + '');
};
;
var parseMoney = function (value, props) {
    if (props === void 0) { props = {}; }
    return round(parseNumber(value, props) * 100, props.decimals || 0);
};
var round = function (value, decimals) {
    var multiplier = Math.pow(10, decimals);
    return Math.round(value * multiplier) / multiplier;
};
var addThousandsSeparator = function (value, thousandsSeparator) {
    return (value + '').replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
};
var addDecimalSeparator = function (base, decimals, decimalSeparator, numDecimals) {
    decimals = decimals + '';
    while (numDecimals && decimals.length < numDecimals) {
        decimals += '0';
    }
    return "".concat(base).concat(decimalSeparator).concat(decimals);
};
var setNested = function (obj, value) {
    if (isArray(obj) || isPlainObject(obj)) {
        var keys = Object.keys(obj);
        keys.map(function (key) {
            obj[key] = setNested(obj[key], value);
        });
    }
    return obj;
};
var swapByPrefixes = function (obj, prefix, otherPrefix) {
    var keys = Object.keys(obj);
    var copy = cloneDeep(obj);
    keys.map(function (key) {
        var otherKey;
        if (key.startsWith(prefix)) {
            otherKey = "".concat(otherPrefix).concat(key.slice(prefix.length));
        }
        else if (key.startsWith(otherPrefix)) {
            otherKey = "".concat(prefix).concat(key.slice(otherPrefix.length));
        }
        if (otherKey) {
            if (copy[otherKey]) {
                obj[key] = copy[otherKey];
            }
            else {
                obj[otherKey] = copy[key];
                delete obj[key];
            }
        }
    });
};
var deleteByPrefix = function (obj, prefix) {
    var keys = Object.keys(obj);
    keys.map(function (key) {
        if (key.startsWith(prefix)) {
            delete obj[key];
        }
    });
};
export { formatNumber, formatInteger, formatMoney, parseNumber, parseInteger, parseMoney, round, setNested, swapByPrefixes, deleteByPrefix };
